module.exports = __webpack_public_path__ + "img/hr-branch-particle-23.d73f2e98.png";